export default "__VITE_ASSET__6c7f14e3__"